var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressBar",style:({ 'max-width': _vm.maxWidth })},[_c('div',{staticClass:"progress",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }